export default "__VITE_ASSET__COSJaOob__"